import { createSelector } from '@ngrx/store';
import * as _ from 'lodash';
import { ListState } from '@industi/ngx-common';

export const createSymfonyTotalCountSelector = (listStateSelector) => createSelector(
  listStateSelector,
  (listState: ListState) => _.get(listState, 'meta.maxResults', null) as number
);
